<template>
    <div>
      <contact-us-header></contact-us-header>
      <contact-us-features></contact-us-features>
    </div>
</template>

<script>
    import ContactUsHeader from './ContactUsHeader';
    import ContactUsFeatures from './ContactUsFeatures';

    export default {
      name: 'ContactUs',
      metaInfo: {
        title: 'Ego | Contact Us',
      },
      components: {
        ContactUsHeader,
        ContactUsFeatures,
      },
    };
</script>

<style scoped>

</style>
